<template>
  <v-main>
    <v-container>
      <div class="desktop">
        <v-row justify="center">
          <v-col md="3" v-for="item in tiles" :key="item.title">
            <v-card
              @click="action(item.component)"
              class="pa-2 pb-0 rounded"
              :class="item.enabled"
              outlined
              tile
              rounded
              color="blue lighten-3"
              elevation="5"
            >
              {{item.title}}
              <div style="position: absolute; bottom:0px; right:0px">
                <v-icon color="blue lighten-4" size="150">{{item.icon}}</v-icon>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <component v-bind:is="dialogContent" :activate="dialogActive" @close-dialog="closeDialog"/>
  </v-main>
</template>

<script>
import AddForm from '../components/AddForms/AddProduct'
export default {
  components: {
    AddForm
  },
  data() {
    return {
      dialogContent: "AddForm",
      dialogActive: false,
      tiles: [
        {
          title: "Historie výroby",
          icon: "mdi-format-list-bulleted",
          enabled: "box-disabled",
          component: "ListSupplier"
        },
        {
          title: "Zahájit výrobu",
          icon: "mdi-playlist-plus",
          enabled: "box",
          component: "AddForm"
        },
        {
         title: "Najít výrobu",
          icon: "mdi-magnify",
          enabled: "box-disabled",
        },
      ],
    };
  },
  methods:{
    action(){
      //this.dialogContent = val
      this.dialogActive = true
    },
    closeDialog(){
      this.dialogActive = false
    }
  }
};
</script>

<style scoped>
main {
  padding: 0px !important;
  background-image: url("../assets/img/landing-bcg.jpg");
  background-position: top top;
  background-repeat: repeat-y;
  background-attachment: fixed;
  background-size: cover;
  background-color: white;
}

</style>